import type { ComponentProps } from 'react';

import { ProfileNonToxicIcon } from '@/features/profile/components/profileNonToxicIcon';
import { useGetMyProfile } from '@/features/profile/hooks/useGetMyProfile';
import { useOpenProfileNonToxicModal } from '@/features/profile/modals/profileNonToxicModal';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/cn';

const transformations = [
  {
    width: 24,
    height: 24,
  },
];

export interface PageHeaderNonToxicBadgeProps extends ComponentProps<'div'> {}

export const PageHeaderNonToxicBadge = (
  props: PageHeaderNonToxicBadgeProps,
) => {
  const { className, ...rest } = props;
  const { data: badges } = useGetMyProfile({
    options: {
      select: data => data.profile?.badges,
    },
  });

  const tierBadge = badges?.[0];

  const tier = tierBadge?.tier ?? 0;
  const recentFeedback = tierBadge?.recentFeedback;

  const openModal = useOpenProfileNonToxicModal();

  return (
    <div
      className={cn('flex items-center justify-center', className)}
      {...rest}
    >
      <Button
        variant="ghost"
        size="icon"
        className="px-0"
        onClick={() => {
          openModal({
            tier,
            recentFeedback,
          });
        }}
      >
        <ProfileNonToxicIcon
          className="size-6"
          transformations={transformations}
          tier={tier}
        />
      </Button>
    </div>
  );
};
